"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorButtonBase = exports.ColorButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../../../i18n/i18n");
var _useTheme = require("../../../../../theme/utils/useTheme");
var _colorUtilities = require("../../../colorPickerUtils/colorUtilities");
var _ColorButtonContextMenu = require("./styled/ColorButtonContextMenu");
var _ColorButtonRoot = require("./styled/ColorButtonRoot");
const ColorButtonBase = /*#__PURE__*/_react.default.forwardRef((props, parentRef) => {
  const {
    className,
    color,
    selected,
    onClick,
    onFocus,
    onKeyDown,
    onRemove,
    tabIndex,
    clientId,
    i18n,
    ...rest
  } = props;
  const [showRemove, setShowRemove] = (0, _react.useState)(false);
  const brightnessValue = (0, _colorUtilities.colorBrightness)(color);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const clickHandler = event => {
    event.stopPropagation();
    onClick(color);
  };
  const contextMenuHandler = event => {
    event.preventDefault();
    if (onRemove && !selected) {
      setShowRemove(true);
    }
  };
  const removeKeyDownHandler = event => {
    const {
      key
    } = event;
    if (key === " " || key === "Enter") {
      onRemove && onRemove(color);
    }
  };
  const removeClickHandler = event => {
    event.stopPropagation();
    onRemove && onRemove(color);
  };
  const hideContextMenu = () => {
    setShowRemove(false);
  };
  (0, _react.useEffect)(() => {
    if (showRemove) {
      window.addEventListener("click", hideContextMenu);
      window.addEventListener("contextmenu", hideContextMenu);
      return () => {
        window.removeEventListener("click", hideContextMenu);
        window.removeEventListener("contextmenu", hideContextMenu);
      };
    }
  }, [showRemove]);
  const styles = {
    color,
    backgroundColor: color
  };
  const checkmarkTheme = {
    icon: {
      "lodestar-light": /*#__PURE__*/_react.default.createElement(_lodestarIcons.CheckIcon, {
        color: brightnessValue < 185 ? (0, _designTokensReact.color)("color--icons--neutral-inverse--default") : (0, _designTokensReact.color)("color--text--neutral--strong")
      }),
      "ursa-light": /*#__PURE__*/_react.default.createElement(_ursaIcons.CheckmarkIcon, {
        size: 24,
        color: brightnessValue < 185 ? (0, _designTokensReact.color)("color--border--surfaces--body") : (0, _designTokensReact.color)("color--border--neutral--strongest")
      })
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ColorButtonRoot.ColorButtonRoot, (0, _extends2.default)({
    style: styles,
    className: className,
    addBorder: brightnessValue > 240,
    selected: selected,
    value: color,
    onClick: clickHandler,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    tabIndex: tabIndex,
    ref: parentRef,
    themeMode: themeMode,
    "data-client-id": clientId,
    onContextMenu: contextMenuHandler,
    type: "button"
  }, rest), selected && checkmarkTheme.icon[themeMode], showRemove && /*#__PURE__*/_react.default.createElement(_ColorButtonContextMenu.ColorButtonContextMenu, {
    tabIndex: 0,
    role: "button",
    onKeyDown: removeKeyDownHandler,
    onClick: removeClickHandler,
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "remove-btn")
  }, /*#__PURE__*/_react.default.createElement(_lodestarIcons.TrashIcon, null), /*#__PURE__*/_react.default.createElement("span", null, i18n._( /*i18n*/{
    id: "Remove"
  }))));
});
exports.ColorButtonBase = ColorButtonBase;
ColorButtonBase.displayName = "ColorButton";
const ColorButton = (0, _i18n.withI18n)(ColorButtonBase);
exports.ColorButton = ColorButton;
//# sourceMappingURL=ColorButton.js.map